module.exports = __webpack_public_path__ + "static/media/circle-facebook.352f0f8c.svg";